<template>
	<div>
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>Volantini</v-toolbar-title>
							<v-spacer></v-spacer>
							<v-text-field v-model="settings.search" prepend-inner-icon="mdi-magnify" placeholder="Cerca per nome" dense outlined hide-details clearable class="fl-search mr-2"></v-text-field>
							<v-toolbar-items shift>
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn elevation="0" text title="Nuovo volantino" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>

						<v-data-table
							:headers="headers"
							:items="getItems"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="fl-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.name || 'Volantino'" :fields="campiCard(item)">
												<template v-slot:actions>
													<FlyerRowMenu :item="item" @edit="editItem" @generate="generate" @copy="copia" @delete="deleteItem" />
												</template>
												<div class="d-flex align-center justify-space-between">
													<span class="card-label">Attivo</span>
													<v-switch v-model="item.active" @change="changeStatus(item)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</div>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="item._id">
										<td class="pl-1 pr-0" style="width: 44px">
											<FlyerRowMenu :item="item" @edit="editItem" @generate="generate" @copy="copia" @delete="deleteItem" />
										</td>
										<td class="font-weight-medium">{{ item.name || '—' }}</td>
										<td>
											<span class="fl-dot" :style="{ background: colore(item) }"></span>
											{{ occasione(item) }}
										</td>
										<td>
											<span v-for="lang in item.langs" :key="lang" class="fl-flag" :title="lang.toUpperCase()">
												<img :src="bandiera(lang)" :alt="lang" />
											</span>
										</td>
										<td>{{ prodotti(item) }}</td>
										<td><FlyerStatusChip :item="item" /></td>
										<td class="fl-sub text-no-wrap">{{ data(item.updated_at) }}</td>
										<td><v-switch v-model="item.active" @change="changeStatus(item)" color="primary" class="mt-0" hide-details></v-switch></td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" multi-line :timeout="snackbar.timeout">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="320">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando il volantino vengono cancellati anche lo sfogliatore e i PDF pubblicati: i link condivisi smetteranno di funzionare.</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>
					<v-btn color="error" text @click="confirmDelete"> Elimina </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import moment from 'moment';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import FlyerRowMenu from '@/components/flyers/FlyerRowMenu.vue';
import FlyerStatusChip from '@/components/flyers/FlyerStatusChip.vue';
import { listRouteState } from '@/components/core/list/listRouteState';
import { bandiera, copiaTesto } from '@/components/flyers/flyerUtils';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'Flyers',
	// pagina, righe, ordinamento e ricerca stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ perPageOptions: LIST_SIZE })],
	components: { KeyValueCard, FlyerRowMenu, FlyerStatusChip },
	data() {
		return {
			snackbar: { snackbar: false, color: '', timeout: 5000, text: '' },
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {},
				options: { sortBy: ['created_at'], sortDesc: [true], page: 1, itemsPerPage: 15 },
			}),
			listSize: LIST_SIZE,
			total: 0,
			headers: [
				{ text: '', value: '', sortable: false },
				{ text: 'Nome', value: 'name' },
				{ text: 'Occasione', value: 'occasion' },
				{ text: 'Lingue', value: 'langs', sortable: false },
				{ text: 'Prodotti', value: 'outputs', sortable: false },
				{ text: 'Stato', value: 'status' },
				{ text: 'Aggiornato', value: 'updated_at' },
				{ text: 'Attivo', value: 'active' },
			],
			presets: {},
			dialogconfirm: false,
			daEliminare: null,
			timer: null,
		};
	},
	sockets: {
		// a generazione finita il backend manda la notifica: si ricarica lo stato
		MESSAGE_NOTIFY() {
			if (this.inGenerazione) this.getDataFromApi(false);
		},
	},
	async created() {
		this.listLoad();
		try {
			this.presets = await this.fetchPresets();
		} catch (e) {
			console.log(e);
		}
		// riserva se il socket non e' collegato: finche' c'e' un volantino in generazione si ricontrolla
		this.timer = setInterval(() => {
			if (this.inGenerazione) this.getDataFromApi(false);
		}, 15000);
	},
	computed: {
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		inGenerazione() {
			return (this.getItems || []).some(i => i.status === 'generating');
		},
		...mapGetters({
			getItems: 'flyers/getItems',
		}),
	},
	methods: {
		...mapMutations({
			setPreload: 'settings/setPreload',
		}),
		...mapActions({
			fetchItems: 'flyers/asyncFetchData',
			fetchPresets: 'flyers/fetchPresets',
			destroyData: 'flyers/destroyData',
			remove: 'flyers/deleteItem',
			setUpdateStatusItem: 'flyers/setUpdateStatusItem',
			generateItem: 'flyers/generate',
		}),
		bandiera,
		occasione(item) {
			return (this.presets[item.occasion] && this.presets[item.occasion].label) || 'Classico';
		},
		colore(item) {
			return (item.theme && item.theme.primary) || (this.presets[item.occasion] && this.presets[item.occasion].theme.primary) || '#0050FF';
		},
		prodotti(item) {
			const out = (item.outputs || [])[0];
			return out ? `${out.products} in ${out.pages} pagine` : '—';
		},
		data(d) {
			return d ? moment(d).format('DD/MM/YYYY HH:mm') : '';
		},
		campiCard(item) {
			return [
				{ label: 'Occasione', value: this.occasione(item) },
				{ label: 'Lingue', value: (item.langs || []).map(l => l.toUpperCase()).join(', ') },
				{ label: 'Prodotti', value: this.prodotti(item) },
				{ label: 'Stato', value: { draft: 'Bozza', generating: 'In generazione', ready: 'Pubblicato', failed: 'Non riuscito' }[item.status] || '' },
			];
		},
		notifica(color, text) {
			this.snackbar = { snackbar: true, color, timeout: 5000, text };
		},
		changeStatus(item) {
			this.setPreload(true);
			this.setUpdateStatusItem({ _id: item._id, active: item.active })
				.then(() => this.notifica('success', 'Stato aggiornato'))
				.catch(err => console.log(err))
				.finally(() => this.setPreload(false));
		},
		editItem(item) {
			this.$router.push(`/flyers/${item._id}`);
		},
		createItem() {
			this.$router.push('/flyers/new');
		},
		generate(item) {
			this.generateItem(item)
				.then(() => {
					this.notifica('success', 'Generazione avviata: ti avvisiamo quando il volantino è pronto');
					return this.getDataFromApi(false);
				})
				.catch(err => this.notifica('error', (err.response && err.response.data && err.response.data.message) || err.message));
		},
		copia(url) {
			copiaTesto(url).then(ok => this.notifica(ok ? 'success' : 'error', ok ? 'Link copiato' : 'Copia non riuscita'));
		},
		getDataFromApi(preload = true) {
			if (preload) this.setPreload(true);
			return this.fetchItems(this.settings)
				.then(result => {
					this.total = result ? result.total : 0;
				})
				.catch(err => console.log(err))
				.finally(() => preload && this.setPreload(false));
		},
		deleteItem(item) {
			this.daEliminare = item;
			this.dialogconfirm = true;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			if (!this.daEliminare) return;
			this.setPreload(true);
			this.remove(this.daEliminare)
				.then(() => this.getDataFromApi())
				.then(() => this.notifica('success', 'Volantino eliminato'))
				.catch(error => console.log(error))
				.finally(() => {
					this.daEliminare = null;
					this.setPreload(false);
				});
		},
	},
	beforeDestroy() {
		clearInterval(this.timer);
		this.destroyData();
	},
};
</script>

<style scoped>
.fl-search {
	max-width: 260px;
}
.fl-sub {
	font-size: 12px;
	color: #5f6b7a;
}
.fl-dot {
	display: inline-block;
	width: 10px;
	height: 10px;
	border-radius: 50%;
	margin-right: 6px;
	vertical-align: middle;
}
.fl-flag img {
	width: 20px;
	height: 14px;
	object-fit: cover;
	border-radius: 2px;
	margin-right: 4px;
	vertical-align: middle;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.fl-cards,
.fl-cards tr {
	display: block;
	width: 100%;
}
.fl-cards tr,
.fl-cards tr:hover {
	background: transparent !important;
}
.fl-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
.fl-cards tr:first-child td {
	padding-top: 12px !important;
}
.fl-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.fl-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
